export default __webpack_public_path__ + "static/media/WAZE.2b850b80.png";